export default __webpack_public_path__ + "static/media/no-charges.793365ac.svg";